// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 28,
  argument: "",
  verses: [
    { n: 1, text: "The wicked man fleeth, when no man pursueth: but the just, bold as a lion, shall be without dread." },
    { n: 2, text: "For the sins of the land many are the princes thereof: and for the wisdom of a man, and the knowledge of those things that are said, the life of the prince shall be prolonged." },
    { n: 3, text: "A poor man that oppresseth the poor, is like a violent shower, which bringeth a famine." },
    { n: 4, text: "They that forsake the law, praise the wicked man: they that keep it, are incensed against him." },
    { n: 5, text: "Evil men think not on judgment: but they that seek after the Lord, take notice of all things." },
    { n: 6, text: "Better is the poor man walking in his simplicity, than the rich in crooked ways." },
    { n: 7, text: "He that keepeth the law, is a wise son: but he that feedeth gluttons, shameth his father." },
    { n: 8, text: "He that heapeth together riches by usury and loan, gathereth them for him that will be bountiful to the poor." },
    { n: 9, text: "He that turneth away his ears from hearing the law, his prayer shall be an abomination." },
    { n: 10, text: "He that deceiveth the just in a wicked way, shall fall in his own destruction: and the upright shall possess his goods." },
    { n: 11, text: "The rich man seemeth to himself wise: but the poor man that is prudent shall search him out." },
    { n: 12, text: "In the joy of the just there is great glory: when the wicked reign, men are ruined." },
    { n: 13, text: "He that hideth his sins, shall not prosper: but he that shall confess, and forsake them, shall obtain mercy." },
    { n: 14, text: "Blessed is the man that is always fearful: but he that is hardened in mind, shall fall into evil." },
    { n: 15, text: "As a roaring lion, and a hungry bear, so is a wicked prince over the poor people." },
    { n: 16, text: "A prince void of prudence shall oppress many by calumny: but he that hateth covetousness, shall prolong his days." },
    { n: 17, text: "A man that doth violence to the blood of a person, if he flee even to the pit, no man will stay him." },
    { n: 18, text: "He that walketh uprightly, shall be saved: he that is perverse in his ways, shall fall at once." },
    { n: 19, text: "He that tilleth his ground, shall be filled with bread: but he that followeth idleness, shall be filled with poverty." },
    { n: 20, text: "A faithful man shall be much praised: but he that maketh haste to be rich, shall not be innocent." },
    { n: 21, text: "He that hath respect to a person in judgment, doth not well: such a man even for a morsel of bread forsaketh the truth." },
    { n: 22, text: "A man that maketh haste to be rich, and envieth others, is ignorant that poverty shall come upon him." },
    { n: 23, text: "He that rebuketh a man, shall afterward find favour with him, more than he that by a flattering tongue deceiveth him." },
    { n: 24, text: "He that stealeth any thing from his father, or from his mother: and saith, This is no sin, is the partner of a murderer." },
    { n: 25, text: "He that boasteth, and puffeth up himself, stirreth up quarrels: but he that trusteth in the Lord, shall be healed." },
    { n: 26, text: "He that trusteth in his own heart, is a fool: but he that walketh wisely, he shall be saved." },
    { n: 27, text: "He that giveth to the poor shall not want: he that despiseth his intreaty, shall suffer indigence." },
    { n: 28, text: "When the wicked rise up, men shall hide themselves: when they perish, the just shall be multiplied." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Pursueth. \"A crime is its own punishment.\" (Seneca, ep. 93.) (Leviticus xxvi. 36.) — Dread. Of any thing terrestrial, as long as the object of his love is not attacked, Romans viii. 35.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Princes. Who each contend for the sovereign power.", attribution: "Calmet" }
    ] },
    { verse: 8, notes: [
      { text: "Poor. It seldom happens that the unjust leave their riches to their children, chap. xiii. 22., and Job xxvii. 16.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "His. Septuagint, \"he rendereth his prayer abominable.\"", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "Mercy. This is true repentance, which enjoins, \"not only to bewail past sins, but also to amend.\" (St. Ambrose, ii. Pen. v.) — Sacramental confession was not required of the Jews, but they confessed their sins, when they laid their hands on the victim, &c., Leviticus iv., and v.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Prudence. Septuagint, \"riches.\" Poverty is a great temptation to people in authority, more than avarice itself.", attribution: "Calmet" }
    ] },
    { verse: 20, notes: [
      { text: "Innocent. Unpunished, if he employ fraud,", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: ", and chap. xiii. 21.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Forsaketh. Hebrew, \"oppresseth (Septuagint, selleth) a man.\" (Calmet) — Neither small nor great bribes must be taken.", attribution: "Justinian" }
    ] },
    { verse: 28, notes: [
      { text: "Men. Septuagint, \"the just groan,\" and all are under \"apprehensions.\"", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
